import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DisplayValueBoolean(props) {
  const {
    value
  } = props;
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: value ? 'customerDataFiltersUI.customerDataFilters.DisplayValue.booleanTrue' : 'customerDataFiltersUI.customerDataFilters.DisplayValue.booleanFalse'
  });
}